import { Direction } from 'types/Utilities';
import Icon from 'components/ui/Icon';
import { useSnapArrows } from 'hooks/useSnapArrows';
import Image from 'components/ui/Image';
import Link from 'components/ui/Link';
import styles from './BlogPosts.module.scss';
import type { BlogItem } from 'types/Blog';

type Props = {
  items: BlogItem[];
  locale: string;
};

const BlogPosts = ({ items, locale }: Props): JSX.Element | null => {
  const { goCarousel } = useSnapArrows('posts-container', 'li');

  if (!items?.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className="py-5">
        <h2>What is FUE Hair Transplant?</h2>
        <ul id="posts-container" className={styles.list}>
          {items.map((item) => {
            return (
              <li key={item.slug} className={styles.item}>
                <article className={styles.article}>
                  <div className={styles.imageWrapper}>
                    <Image
                      src={item.bannerImage?.url || ''}
                      alt={item.title}
                      className={styles.image}
                      fill
                    />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>
                </article>
                <Link
                  className="stretched-link"
                  legacyBehavior={false}
                  href={`/${locale}/blog/${item.slug}`}
                  title={item.title}
                >
                  &nbsp;
                </Link>
              </li>
            );
          })}
        </ul>
        <Icon
          type="Arrow"
          direction={Direction.LEFT}
          className="bg-white rounded-full h-8 w-8 p-2 left-0 -ml-0 absolute cursor-pointer hover:bg-bluishGrey hidden md:block"
          color="#155263"
          style={{
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          onClick={() => {
            goCarousel('previous');
          }}
        />
        <Icon
          type="Arrow"
          direction={Direction.RIGHT}
          className="bg-white rounded-full h-8 w-8 p-2 right-0 -mr-0 absolute cursor-pointer hover:bg-bluishGrey hidden md:block"
          color="#155263"
          style={{
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
            top: '50%',
            transform: 'translate(50%, -50%)',
          }}
          onClick={() => {
            goCarousel('next');
          }}
        />
      </div>
    </div>
  );
};

export default BlogPosts;
